// The algorithm itself finishes in milliseconds. Its courses are spread over
// about this long so a planner sees the counts tick up rather than a spinner
// flash; set to 0 to run at full speed.
export const SIMULATION_DURATION_MS = 2000;
// A run of only a few courses would otherwise hold each one for most of a
// second, which reads as the dialog being stuck.
export const SIMULATION_MAX_COURSE_STEP_MS = 250;

// The most of every profession's working hours that may be booked in total,
// the plans already on the year plan included; the rest is headroom for
// sickness and the unexpected.
export const DEFAULT_MAX_STAFF_LOAD_PERCENT = 90;
export const MAX_STAFF_LOAD_FLOOR_PERCENT = 10;
export const MAX_STAFF_LOAD_CEILING_PERCENT = 100;
